import type { KeyboardShortcut } from "src/utils/useKeyboardShortcut.ts";

export const AI_ASSISTANT_TOGGLE_SHORTCUT: KeyboardShortcut = {
	ctrlOrMeta: true,
	key: "a",
	shift: true,
};
